var React = require('react');

function Waves (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#766b5e","fillOpacity":"1","d":"M0,256L30,245.3C60,235,120,213,180,176C240,139,300,85,360,96C420,107,480,181,540,192C600,203,660,149,720,149.3C780,149,840,203,900,213.3C960,224,1020,192,1080,165.3C1140,139,1200,117,1260,117.3C1320,117,1380,139,1410,149.3L1440,160L1440,0L1410,0C1380,0,1320,0,1260,0C1200,0,1140,0,1080,0C1020,0,960,0,900,0C840,0,780,0,720,0C660,0,600,0,540,0C480,0,420,0,360,0C300,0,240,0,180,0C120,0,60,0,30,0L0,0Z"}));
}

Waves.defaultProps = {"viewBox":"0 0 1420 260"};

module.exports = Waves;

Waves.default = Waves;
